import { getDownloadURL, ref, getBlob } from "firebase/storage";
import { auth, appStorage } from "../../firebase";
import { useEffect, useState } from "react";
import Button, { BtnProps } from "../../components/button/Button";
import InputFile from "../../components/input/InputFile";
import { ModalAndAlmightyDialog } from "../../components/modal/ModalAndAlmightyDialog";
import ExcelJS, { CellHyperlinkValue, CellRichTextValue, CellFormulaValue } from "exceljs";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { Company } from "../../model/Companies";
import { Groups } from "../../model/Groups";
import { ReplyButton } from "../../model/ReplyButton";
import companiesQuery from "../../firestore/Companies.query";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";
import messagesQuery from '../../firestore/Messages.query';
import { Messages } from "../../model/Message";
import { Progress } from "../../components/progress/Progress";
import { createEvenReplyButtons } from "../../utility/CreateEventReplyButtonUtility";
import { Spiner } from "../../components/spinner/Spiner";
import { compareDateOnlyTime, compareDateOnlyYmd, getImportErrorFileNamePrefix, stringToDate, nineHourMinusDate } from "../../utility/CommonUtility";

type Items = {
  url: string;
  name: string;
}

export const MessageRegister = () => {

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  const dispatch = useDispatch();

  const [messageRef, setMessageRef] = useState<Items>();
  const [scheduleRef, setScheduleRef] = useState<Items>();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [dialogActions, setDialogActions] = useState<BtnProps[]>([]);
  const [loadProgress, setLoadProgress] = useState<number>(-1);
  const [company, setCompany] = useState<Company>();
  const [groupList, setGroupList] = useState<Groups[]>();
  const [replyButtonList, setReplyButtonList] = useState<ReplyButton[]>();
  const [fileDataInfo, setFileDataInfo] = useState<any[]>([]);
  const [isImport, setIsImport] = useState(false);
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const [dialogChildren, setDialogChildren] = useState<React.ReactNode | undefined>();
  const [targetFile, setTargetFile] = useState<File>();
  const [messageKind, setMessageKind] = useState<string>('');
  const [isNotificationCount, setIsNotificationCount] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [checkedRowCnt, setCheckedRowCnt] = useState(0);

  const messageFileName = "一括登録フォーマット（お知らせ）.xlsx";
  const scheduleFileName = "一括登録フォーマット（予定表）.xlsx";

  /** 一括登録フォーマット列番号：タイトル */
  const COL_NUM_TITLE = 2;
  /** 一括登録フォーマット列番号：内容 */
  const COL_NUM_BODY = 3;
  /** 一括登録フォーマット列番号：配信日 */
  const COL_NUM_SENDDATE = 7;
  /** 一括登録フォーマット列番号：配信時分 */
  const COL_NUM_SENDTIME = 8;
  /** 一括登録フォーマット列番号：掲載終了日 */
  const COL_NUM_PUB_END = 9;
  /** 一括登録フォーマット列番号：配信先 */
  const COL_NUM_SELECT_DELIVER = 10;
  /** 一括登録フォーマット列番号（返信ボタンからの番号）：イベント開催日 */
  const COL_NUM_EVENTDATE = 2;
  /** 一括登録フォーマット列番号（返信ボタンからの番号）：イベント開始時間 */
  const COL_NUM_EVENTSTART = 3;
  /** 一括登録フォーマット列番号（返信ボタンからの番号）：イベント終了時間 */
  const COL_NUM_EVENTEND = 4;

  useEffect(() => {
    const f = async () => {
      // お知らせ用ExcelフォーマットのURL取得
      const itemRef = ref(appStorage, `format/bulkRegist/${messageFileName}`);
      const downloadMessageUrl: string = await getDownloadURL(itemRef);
      setMessageRef({...messageRef, url:downloadMessageUrl, name:messageFileName});
      // 予定表用ExcelフォーマットのURL取得
      const itemRef2 = ref(appStorage, `format/bulkRegist/${scheduleFileName}`);
      const downloadScheduleUrl: string = await getDownloadURL(itemRef2);
      setScheduleRef({...scheduleRef, url:downloadScheduleUrl, name:scheduleFileName});
      // 団体情報の取得
      const company = await companiesQuery.getCompany(currentUser?.tenantId!);
      setCompany(company);
      // グループ一覧
      const groups = await companiesQuery.getGroups(currentUser?.tenantId!);
      setGroupList(groups);
      // 返信ボタン一覧
      const replyButtons = await companiesQuery.getReplyButtons(currentUser?.tenantId!);
      setReplyButtonList(replyButtons);
    };
    f();
  },[]);

  // インポート完了ダイアログ用プロパティ
  useEffect(() => {
    const fileKind = messageKind == "message" ? "お知らせ" : "予定表";
    if(loadProgress >= 100 && isImport) {
      const successCnt = fileDataInfo.filter((item) => item.status === "success").length;
      const failedCnt = fileDataInfo.filter((item) => item.status === "failed").length;
      if(failedCnt === 0) {
        // 取込NGなし
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "OK",
            onClick: () => {
              setIsOpenDialog(false);
              initDialog();
            }
          },
        ];
        if(isNotificationCount === true){
          let dialogTitle = "";
          let dialogChild = undefined;
          if (0 < successCnt) {
            // 取込OKあり
            dialogTitle = ConstMessage.IMPORT_SUCCESS_MESSAGE_DIALOG_TITLE.replace('%1', fileKind);
            dialogChild = (<>
              <div>{ConstMessage.IMPORT_SUCCESS_DIALOG_TEXT.replace('%1', successCnt.toString())}</div><br/>
              <div className={'whitespace-pre'}>{ConstMessage.IMPORT_FAILED_MESSAGE_DIALOG_SUB_TEXT.replace('%1', fileKind).replace('%2', fileKind)}</div><br/></>);
          } else {
            // 取込なし
            dialogTitle = ConstMessage.IMPORT_NO_DATA_TITLE;
          }

          setIsImport(false);
          setIsOpenDialog(true);
          setDialogTitle(dialogTitle);
          setDialogChildren(dialogChild);
          setDialogActions(actions);
          setLoadProgress(-1);
          setIsNotificationCount(false);
        }
      } else {
        // 取込NGあり
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "ファイルのダウンロード",
            onClick: () => {
              setIsOpenDialog(false);
              setProgress(0);
              downloadErrorFile().then(() => {
                setProgress(100);
                setTargetFile(undefined);
                setFileDataInfo([]);
                initDialog();
              });
            }
          },
        ];

        const dialogTitle = 0 < successCnt ? ConstMessage.IMPORT_FAILED_MESSAGE_DIALOG_TITLE : ConstMessage.IMPORT_FAILED_ALL_MESSAGE_DIALOG_TITLE;
        const dialogChild = (<>
          {0 < successCnt ?
            <>
              <div>{ConstMessage.IMPORT_FAILED_DIALOG_TEXT.replace('%1', successCnt.toString()).replace('%2', failedCnt.toString())}</div><br/>
              <div className={'whitespace-pre'}>{ConstMessage.IMPORT_FAILED_MESSAGE_DIALOG_SUB_TEXT.replace('%1', fileKind).replace('%2', fileKind)}</div><br/>
            </> : <>
              <div>{ConstMessage.IMPORT_FAILED_ALL_DIALOG_TEXT.replace('%1', failedCnt.toString())}</div><br/>
            </>
          }
          <div className={'text-red-500 whitespace-pre'}>{ConstMessage.IMPORT_FAILED_DIALOG_TEXT_WORNING}</div>
        </>);

        setIsImport(false);
        setIsOpenDialog(true);
        setDialogTitle(dialogTitle.replace('%1', fileKind));
        setDialogChildren(dialogChild);
        setDialogActions(actions);
        setLoadProgress(-1);
      }
    }
  }, [loadProgress, isImport, fileDataInfo, isNotificationCount]);

  // プログレスバー
  const setProgress = (progress: number) => {
    setLoadProgress(progress);
  }

  // フォーマットのダウンロード
  const onDownload = async (item?: Items) => {
    if(item){
      try{
        let fileName = "";
        if(item.name === messageFileName){
          fileName = messageFileName;
        }else{
          fileName = scheduleFileName;
        }
        const itemRef = ref(appStorage, `format/bulkRegist/${fileName}`);
        const excelblob = await getBlob(itemRef);
        const blobURL = window.URL.createObjectURL(excelblob as Blob);
        const promise = new Promise<any>(() => {
          const xhr = new XMLHttpRequest();
          xhr.onload = async () => {
            const result = xhr.response;
            const data = new Uint8Array(result);
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(data as any);
            const uint8Array = await workbook.xlsx.writeBuffer();
            const blob = new Blob([uint8Array], { type: "application/octet-binary" });
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link)
            dispatch(alertOpen(AlertValue("ダウンロードに成功しました。", "success")));
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          }
          xhr.responseType = "arraybuffer";
          xhr.open("GET", blobURL);
          xhr.send(null); 
        })
        return promise;
      }catch (err: any) {
        console.log(err);
        dispatch(alertOpen(AlertValue("ダウンロードに失敗しました。", "danger")));
      }
    }
  }

  // 注釈設定
  const annotation = [
    ["※*は必須項目のため、必ず入力してください。"], // 2行目
    ["※4、5行目は項目名のため変更しないでください。"], // 3行目
  ];

  // 項目名
  const column = [
    { header: "No.", key: "no" },
    { header: "タイトル＊", key: "title" },
    { header: "内容＊", key: "body" },
    { header: "問い合わせ先", key: "contactInformation" },
    { header: "URLボタン名", key: "urlButtonName" },
    { header: "URL", key: "urlLink"},
    { header: "配信日＊", key: "sendDate"},
    { header: "時分＊", key: "sendDateTime"},
    { header: "掲載終了日", key: "publishEndAt"},
    { header: "配信先＊", key: "select"},
    { header: "配信先グループ", key: "topic"},
  ];
  const endColumn = [
    { header: "返信ボタン", key: "replyButton"},
  ];

  // 項目名（予定表）
  const scheduleColumn = [
    { header: "イベントタイプ", key: "eventType" },
    { header: "イベント開催日＊", key: "eventAt" },
    { header: "開始時間＊", key: "eventAtTime" },
    { header: "終了時間＊", key: "eventEndAt" },
    { header: "会場", key: "eventVenue" },
    { header: "ミーティングURL", key: "link" },
  ]

  const getTargetCol = (targetCol: ExcelJS.Row, targetColName: String) => {
    for (let i = 1; i <= targetCol.cellCount; i++) {
      // セルの値を取得
      let cellText = getCellText(targetCol.getCell(i).value);
      if(cellText === targetColName) return i;
    }
    return -1;
  };

  // セルの値を取得
  function getCellText(cellValue: any) {
    const cellRichText = cellValue as CellRichTextValue;
    const cellLink = cellValue as CellHyperlinkValue;
    const cellFormula = cellValue as CellFormulaValue;
    let cellText;
    if (cellValue === null) {
      cellText = ''
    } else if (cellRichText.richText !== undefined) {
      // richText
      cellText = cellRichText.richText[0].text ?? '';
    } else if (cellLink.hyperlink !== undefined) {
      // hyperLink
      cellText = cellLink.text ?? '';
    } else if(cellFormula.result !== undefined) {
      cellText = cellFormula.result?.toString() ?? '';
    } else {
      // 上記以外
      cellText = cellRichText.toString() ?? '';
    }
    return cellText;
  }

  // 時間のフォーマットを行う
  const dateHourFormat = (date: Date) => {
    const hour = date.getHours()-9;
    let hourValue = hour;
    if(hour < 0){
      hourValue = hourValue + 24;
    }
    return hourValue;
  }

  // Date型か判定
  const isInvalidDate = (date: any) => { 
    let flg = false;
    const formatDate = new Date(date);
    if(Number.isNaN(formatDate.getTime())){
      const newDate = formatTime(date, new Date());
      if(Number.isNaN(newDate.getTime())){
        flg = true;
      }
    }
    return flg;
  }

  // 過去日かどうか
  const isPastDate = (targetDate: Date, baseDate: Date) => {
    // 基準日
    let nYear = baseDate.getFullYear();
    let nMonth = baseDate.getMonth() + 1;
    let nDay = baseDate.getDate();

    // 比較対象日
    let tYear = targetDate.getFullYear();
    let tMonth = targetDate.getMonth() + 1;
    let tDay = targetDate.getDate();

    if (tYear == nYear) {
      if (tMonth == nMonth) {
          return tDay < nDay;
      }
      else {
          return tMonth < nMonth;
      }
    } else {
        return tYear < nYear;
    }
  }

  // 日付の取得
  const formatDateTime = (time: any, date: Date) => {
    const newTime = new Date(time);
    if(!Number.isNaN(newTime.getTime())){
      // Date型の場合
      const timeFormat = new Date(time);
      const hourValue = dateHourFormat(timeFormat);
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hourValue, timeFormat.getMinutes());
    }
    // string型の場合
    return formatTime(time, date);
  }

  // string型の時間を日付に変換
  const formatTime = (time: any, date: Date) => {
    let str = ':';
    const strIdx = time.indexOf(str);
    if(strIdx < 0){
      str = '：';
    }
    const hh = time.substr(0, time.indexOf(str));
    const mm = time.substr(time.indexOf(str) + 1);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hh, mm);
  }

  // string型の日付か判定
  const dateJudg = (date: any) => {
    let flg = false;
    const strIdx = date.indexOf("/");
    const deleteStr = (txt: string) => txt.replace(/\/$/i,'');
    let yyyy = date.substr(0, 4);
    let mm = Number(deleteStr(date.substr(strIdx + 1, 2)));
    let dd = Number(deleteStr(date.slice(-2, 2)));
    const newDate = new Date(yyyy, mm, dd);
    if(typeof date == "string"){
      if(!Number.isNaN(newDate.getTime())){
        flg = true;
      }
    }
    return flg;
  };

  // string型の時間か判定
  const timeJudg = (time: any) => {
    let flg = false;
    if(typeof time == "string"){
      const newDate = formatTime(time, new Date());
      if(!Number.isNaN(newDate.getTime())){
        flg = true;
      }
    }
    return flg;
  }

  const convertDateToStringCompactFormat = (date: Date) => {
    const yyyy = String(date.getFullYear());
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}${mm}${dd}`;
  };
  

  const onImport = async (
    messageKinds: string,
    format: 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsLoad(true);
    setMessageKind(messageKinds);
    const importWorningMessage = (<div>※Excelに記載した内容で{messageKinds == "message"? "お知らせ" : "予定表"}を一括登録します。</div>);
    const importAllWorningMessage = (<div className={'text-red-500'}>
      ※Excel取込は、件数によって<span className={"font-bold text-red-700"}>作業時間が長時間になる場合があります。</span><br/>
      ※一度実行すると中止することはできません。
    </div>);

    // インポート前確認ボタンアクション
    const getBtnActions = (res: string) => {
      if (res) {
        // エラーがある場合：OKのみ（閉じるのみ）
        const actions: BtnProps[] = [
          {
            color: "indigo",
            children: "OK",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
            }
          },
        ];
        return actions;

      } else {
        // エラーがない場合：OK or キャンセル
        const actions: BtnProps[] = [
          {
            color: "indigo",
            outline: true,
            children: "キャンセル",
            className:"w-[132px]",
            onClick: () => {
              e.target.value = '';
              setIsOpenDialog(false);
            }
          },
          {
            color: "indigo",
            children: "OK",
            className:"w-[132px]",
            onClick: () => {
              e.target.value = '';
              importMessage(messageKinds, format, file, e);
              setIsOpenDialog(false);
            }
          },
        ];
        return actions;
      }
    };

    // インポート前確認ダイアログ
    checkImport(messageKinds, file).then((res) => {
      const importErrorMessage = (
        <div className={'text-red-500'}>
          {res !== null?(<>{res}</>):(<></>)}  
        </div>);

      const dialogChildren = (<>
        {res !== null
          ? "ファイルチェックでエラーが発生しました。ファイルを確認してください。"
          : "ファイルチェックが完了しました。以下のExcelファイルの内容を登録しますか？"}
        <ul className={`list-disc m-2 text-${format === 'xlsx' ? 'green' : 'yellow' }-700`}>
          <li className={"flex"}><DocumentArrowUpIcon className={"h-6 w-6"}/>{file?.name}</li>
        </ul>
        {res !== null ? "" : importWorningMessage}
        {res !== null ? "" : importAllWorningMessage}
        {res !== null ? importErrorMessage : ""}
      </>)

      setIsOpenDialog(true);
      setDialogTitle("Excel一括取込確認");
      setDialogChildren(dialogChildren);
      setDialogActions(getBtnActions(res));
    });
  };

  // インポート前ファイルチェック
  const checkImport = async (
    messageKinds: string,
    file: File | null,
  ) => {
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try{
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = {orientation:'portrait'};
          // n行目から項目リストを取得して正しいファイルか確認
          const headerRowNum = annotation.length + 3;
          const columnHeader = worksheet.getRow(headerRowNum);
          const listHeader = column.map((item) => item.header);
          for (let i = 0; i < column.length; i++){
            // ヘッダ行のテキストを取得
            const headerCellText = getCellText(columnHeader.getCell(i + 1).value);
            if(listHeader[i] !== headerCellText){
              throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
            }
          };
          // 返信ボタンがどこにあるか確認
          const replyButtonName = messageKinds === "message" ? endColumn[0].header : endColumn[0].header + "＊";
          const endLineCol = getTargetCol(columnHeader, replyButtonName);
          if (endLineCol < 0) {
            throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
          }
          if(messageKinds == "message"){
            const colValue = getCellText(columnHeader.getCell(endLineCol + 1).value);
            if(!(colValue == "" || colValue == "取込結果")){
              throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
            }
          }
          // 予定表の場合の項目名を確認
          if(messageKinds == "schedule"){
            const scheduleColumnHeader = worksheet.getRow(headerRowNum);
            const schedulelistHeader = scheduleColumn.map((item) => item.header);
            const startScheduleCol = endLineCol + 1;
            for (let i = startScheduleCol; i < startScheduleCol + scheduleColumn.length; i++){
              // ヘッダ行のテキストを取得
              const headerCellText = getCellText(scheduleColumnHeader.getCell(i).value);
              if(schedulelistHeader[i-startScheduleCol] !== headerCellText){
                throw new Error(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
              }
            };
          }
          resolve(null);
          setIsLoad(false);
        }catch (e: any) {
          console.error(e);
          resolve(ConstMessage.ERR_FORMAT_USER_IMPORT_FILE);
          setIsLoad(false);
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });
    return promise;
  }

  const importMessage = async (
    messageKinds: string,
    format: 'xlsx',
    file: File | null,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    importData(messageKinds, format, file).then(async (res) => {
      setFileDataInfo(res.data);
      setIsNotificationCount(true);
      e.target.value = '';
      if(res.status == "failed"){
        // １件でもインポートに失敗した場合
        let errorList: string[] = [];
        res.data.map((item: any, index: number) => {
          if(item.status == "error"){
            errorList.push(String(index + 1) + "行目");
          }        
        });
        if(errorList.length > 0){
          dispatch(alertOpen(AlertValue(errorList.join(",") + "のインポートに失敗しました。", "danger")));
        }
      }
    });
  };


  // 入力処理
  const importData = async (
    messageKinds: string,
    format: 'xlsx',
    file: File | null,
  ) => {
    const blobURL = window.URL.createObjectURL(file as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      setLoadProgress((0));
      setIsImport(true);
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try{
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.columns = column;
          worksheet.pageSetup = {orientation:'portrait'};
          const headerRowNum = annotation.length + 3;
          const columnHeader = worksheet.getRow(headerRowNum);
          const replyButtonName = messageKinds === "message" ? endColumn[0].header : endColumn[0].header + "＊";
          const endCol = getTargetCol(columnHeader, replyButtonName);
          const resultCol = getTargetCol(columnHeader, '取込結果');

          const recordResult = [];
          // 7行目からDB保存(例は含めない)
          const startRow = headerRowNum + 2;
          const targetRowCnt = resultCol >= 0 ?
                                worksheet.rowCount + 1 - startRow - worksheet.getColumn(resultCol).values.filter((value) => value === "○").length :
                                worksheet.rowCount + 1 - startRow;
          let processRowCnt = 0;
          // 入力チェックをする行数を取得
          let checkedRowCnt = 0;
          for (let i = startRow; i < worksheet.rowCount + 1; i++) {
            const row = worksheet.getRow(i);
            const title = getCellText(row.getCell("title").value) != "-" ? getCellText(row.getCell("title").value) : "";
            const body = getCellText(row.getCell("body").value) != "-" ? getCellText(row.getCell("body").value) : "";
            if(title === "" && body === ""){
              checkedRowCnt = i;
              setCheckedRowCnt(checkedRowCnt);
              break;
            }else if(i === worksheet.rowCount){
              // 500件登録の場合
              checkedRowCnt = worksheet.rowCount + 1;
              setCheckedRowCnt(checkedRowCnt);
            }
          }
          // 入力チェックを行う
          for (let i = startRow; i < checkedRowCnt; i++) {
            processRowCnt++;
            const row = worksheet.getRow(i);
            if(resultCol >= 0){
              // エラーファイルの場合
              const result = getCellText(row.getCell(resultCol).value);
              if (result === "○") {
                // 読取結果が ○ の場合
                processRowCnt--;
                const progress = Math.round(processRowCnt / targetRowCnt * 100);
                setProgress(progress);
                continue;
              }
            }
            const rowData = getRowData(row, endCol, messageKinds);
            const targetRowError = await targetRowDataCheck(rowData, messageKinds, endCol);

            if (targetRowError.length <= 0) {
              // 処理行のデータにエラーがない場合
              try{
                let topicList: string[] = [];
                if(rowData.select == "topic"){
                  rowData.topic.forEach((target) => {
                    let topicItem = groupList?.filter((item) => item.name === target.name)[0];
                    if (!(topicItem === undefined || topicItem === null)) {
                      topicList.push(topicItem.id);
                    }
                  })
                }else{
                  topicList.push(company?.displayId!);
                }
                // データの新規登録
                let data: Messages = {
                  id: "",
                  tenantId: currentUser?.tenantId!,
                  title: rowData.title,
                  body: rowData.body,
                  urlButtonFlg: rowData.urlButtonName == "" && rowData.urlLink == "" ? false : true,
                  urlButtonName: rowData.urlButtonName,
                  urlLink: rowData.urlLink,
                  image: "",
                  contactInformation: rowData.contactInformation,
                  eventVenue: rowData.eventVenue ?? "",
                  type: "",
                  link: (rowData.link == undefined || rowData.link == "") ? "none" : rowData.link,
                  fileupload: "",
                  topic: topicList,
                  draftFlg: true,
                  authorUid: currentUser?.uid!,
                  authorName: currentUser?.displayName!,
                  deliveredFlg: false,
                  eventFlg: messageKinds == "schedule" ? true : false,
                  eventAt: rowData.eventAt ?? new Date(),
                  eventEndAt: rowData.eventEndAt ?? new Date(),
                  eventType: rowData.eventType ?? "",
                  publishEndAt: rowData.publishEndAt ?? undefined,
                  sendDate: rowData.sendDateValue,
                  replyButton: rowData.replyButton,
                  createAt: new Date(),
                  select: rowData.select ?? "",
                  url: "https://",
                  questionnaireFlg: false,
                  questionnaireSendFlg: false
                }

                if(data.publishEndAt == undefined){
                  delete data.publishEndAt;
                }
                // 返信ボタンの登録
                let replyButtonSelected = undefined;
                if(messageKinds == "schedule" && rowData.replyButton != ""){
                  replyButtonSelected = createEvenReplyButtons().filter((item) => item.name === rowData.replyButton)[0];
                  replyButtonSelected.tenantId = currentUser?.tenantId!;
                }else if(rowData.replyButton != ""){
                  replyButtonSelected = replyButtonList?.filter((item) => item.name === rowData.replyButton)[0];
                }
                
                const result = await messagesQuery.addMessage(data, undefined, replyButtonSelected);
                if(!result){
                  throw new Error(ConstMessage.IMPORT_ERR_MSG);
                }

                recordResult.push({
                  rowNumber : i,
                  status: 'success'
                });
              } catch (e) {
                // 例外発生
                recordResult.push({
                  rowNumber : i,
                  status: 'error',
                  message: e
                });
              }
            } else {
              // 処理行のデータにエラーがある場合
              recordResult.push({
                rowNumber : i,
                status: 'failed',
                info: targetRowError
              });
            }
            const progress = Math.round(processRowCnt / checkedRowCnt * 100);
            setProgress(progress);
          }
          setProgress(100);

          if (recordResult.filter((item) => item.status !== "success").length > 0) {
            // インポートできないデータが1件以上存在する場合
            resolve({status: "failed", data: recordResult});
          } else {
            // すべてインポートできた場合
            resolve({status: "success", data: recordResult});
          }
        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(e.toString(), "danger")));
          setLoadProgress(-1);
          resolve({status: "error", data: e})
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", blobURL);
      xhr.send(null);
    });
    return promise;
  };

  /**
   * 処理行のデータを返す
   */
  const getRowData = (row: ExcelJS.Row, endCol: number, messageKinds: string) => {
    const title = getCellText(row.getCell("title").value) != "-" ? getCellText(row.getCell("title").value) : "";
    const body = getCellText(row.getCell("body").value) != "-" ? getCellText(row.getCell("body").value) : "";
    const contactInformation = getCellText(row.getCell("contactInformation").value) != "-" ? getCellText(row.getCell("contactInformation").value) : "";
    const urlButtonName = getCellText(row.getCell("urlButtonName").value) != "-" ? getCellText(row.getCell("urlButtonName").value) : "";
    const urlLink = getCellText(row.getCell("urlLink").value) != "-" ? getCellText(row.getCell("urlLink").value) : "";
    const sendDate = getCellText(row.getCell("sendDate").value) != "-" ? getCellText(row.getCell("sendDate").value) : "";
    const sendDateTime = getCellText(row.getCell("sendDateTime").value) != "-" ? getCellText(row.getCell("sendDateTime").value) : "";
    const sendDateTimeStyle = row.getCell("sendDateTime").style;
    const date = new Date(sendDate);
    let sendDateResult;
    if(sendDateTime != ""){
      sendDateResult = formatDateTime(sendDateTime, date);
    }else{
      sendDateResult = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    const publishEndAt = getCellText(row.getCell("publishEndAt").value) != "-" ? getCellText(row.getCell("publishEndAt").value) : "";
    let publishEndAtResult = null;
    if(publishEndAt != ""){
      const publishEndAtDate = new Date(publishEndAt);
      publishEndAtResult = new Date(publishEndAtDate.getFullYear(), publishEndAtDate.getMonth(), publishEndAtDate.getDate(), publishEndAtDate.getHours()-9);
    }
    const select = getCellText(row.getCell("select").value) != "-" ? getCellText(row.getCell("select").value) : "";
    let selectValue = "";
    if(select == "全体"){
      selectValue = company?.displayId ?? "";
    }else if(select == "グループ"){
      selectValue = "topic";
    }else if(select != ""){
      selectValue = select;
    }
    const topicList = [];
    for(let j = 11; j < endCol; j++) {
      const targetColTopic = getCellText(row.getCell(j).value) != "-" ? getCellText(row.getCell(j).value) : "";
      if (targetColTopic !== "") {
        topicList.push({col: j, name: targetColTopic});
      }
    }
    const replyButton = getCellText(row.getCell(endCol).value) != "-" ? getCellText(row.getCell(endCol).value) : "";

    if(messageKinds == "message"){
      return {
        title: title,
        body: body,
        contactInformation: contactInformation,
        urlButtonName: urlButtonName,
        urlLink: urlLink,
        sendDate: sendDate,
        sendDateValue: sendDateResult,
        sendDateTime: sendDateTime,
        sendDateTimeStyle: sendDateTimeStyle,
        publishEndData: publishEndAt,
        publishEndAt: publishEndAtResult,
        select: selectValue,
        topic: topicList,
        replyButton: replyButton,
      };
    };
    // 予定表のデータ
    const eventType = getCellText(row.getCell(endCol + 1).value) != "-" ? getCellText(row.getCell(endCol + 1).value) : "";
    const eventAt = getCellText(row.getCell(endCol + 2).value) != "-" ? getCellText(row.getCell(endCol + 2).value) : "";
    const eventAtStyle = row.getCell(endCol + 2).style;
    const eventAtTime = getCellText(row.getCell(endCol + 3).value) != "-" ? getCellText(row.getCell(endCol + 3).value) : "";
    const eventAtTimeStyle = row.getCell(endCol + 3).style;
    const eventEndAtTime = getCellText(row.getCell(endCol + 4).value) != "-" ? getCellText(row.getCell(endCol + 4).value) : "";
    const eventEndAtTimeStyle = row.getCell(endCol + 4).style;
    const eventDate = new Date(eventAt);
    let eventDateResult = undefined;
    let eventEndResult = undefined;
    let eventAtDateTimeResult = undefined;
    if(eventAtTime != ""){
      eventDateResult = formatDateTime(eventAtTime, eventDate);
    } else {
      eventAtDateTimeResult = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
    }
    if(eventEndAtTime != ""){
      eventEndResult = formatDateTime(eventEndAtTime, eventDate);
    }
    const eventVenue = getCellText(row.getCell(endCol + 5).value) != "-" ? getCellText(row.getCell(endCol + 5).value) : "";
    const link = getCellText(row.getCell(endCol + 6).value) != "-" ? getCellText(row.getCell(endCol + 6).value) : "";
    
    return {
      title: title,
      body: body,
      contactInformation: contactInformation,
      urlButtonName: urlButtonName,
      urlLink: urlLink,
      sendDate: sendDate,
      sendDateValue: sendDateResult,
      sendDateTime: sendDateTime,
      sendDateTimeStyle: sendDateTimeStyle,
      publishEndData: publishEndAt,
      publishEndAt: publishEndAtResult,
      select: selectValue,
      topic: topicList,
      replyButton: replyButton,
      eventType: eventType,
      eventAtDate: eventAt,
      eventAtDateTime: eventAtDateTimeResult,
      eventAt: eventDateResult,
      eventAtStyle: eventAtStyle,
      eventAtTime: eventAtTime,
      eventAtTimeStyle: eventAtTimeStyle,
      eventEndAt: eventEndResult,
      eventEndAtTime: eventEndAtTime,
      eventEndAtTimeStyle: eventEndAtTimeStyle,
      eventVenue: eventVenue,
      link: link,
    };
  };

  // 処理行のデータにエラーがないか確認を行う
  const targetRowDataCheck = async (rowData: any, messageKinds: string, endCol: number) => {
    const errArrRequired = [];
    const errArrInvalidValue = [];
    const errArrBeforeSendDate = [];
    const errArrBeforeRegistDate = [];
    const errArrBeforePubEndDate = [];
    const errArrBeforeSendTime = [];
    const errArrBeforeEventTime = [];
    const date = new Date();

    // 必須項目チェック
    if(rowData.title.length == 0){
      errArrRequired.push(getErrorDataItem('title'));
    }
    if(rowData.body.length == 0){
      errArrRequired.push(getErrorDataItem('body'));
    }
    if(rowData.sendDate.length == 0){
      errArrRequired.push(getErrorDataItem('sendDate'));
    }
    if(rowData.sendDateTime.length == 0){
      errArrRequired.push(getErrorDataItem('sendDateTime'));
    }
    if(rowData.select.length == 0 || rowData.select === "　"){
      errArrRequired.push(getErrorDataItem('select'));
    }
    if (rowData.select == "topic" && rowData.topic.length == 0){
      errArrRequired.push(getErrorDataItem('topic'));
    }
    if(messageKinds == "schedule"){
      if(rowData.replyButton.length == 0){
        errArrRequired.push({colNo: [endCol], colName: "返信ボタン"});
      }
      if(rowData.eventAtDate.length == 0){
        errArrRequired.push(getErrorDataItem('eventAt', endCol));
      }
      if(rowData.eventAtTime.length == 0){
        errArrRequired.push(getErrorDataItem('eventAtTime', endCol));
      }
      if(rowData.eventEndAtTime.length == 0){
        errArrRequired.push(getErrorDataItem('eventEndAt', endCol));
      }
    }
    
    // --- 入力値チェック ---

    // URLボタン：URL
    if (rowData.urlLink.length > 0 && !(rowData.urlLink.startsWith('https://'))){
      errArrInvalidValue.push(getErrorDataItem('urlLink'));
    } else {
      if (0 < rowData.urlLink.length && rowData.urlButtonName.length === 0) {
        // URLボタン名未入力
        errArrRequired.push(getErrorDataItem('urlButtonName'));
      } else if (0 === rowData.urlLink.length && 0 < rowData.urlButtonName.length) {
        // URL未入力
        errArrRequired.push(getErrorDataItem('urlLink'));
      }
    }

    // 配信日
    if (rowData.sendDate.length > 0) {
      if (isInvalidDate(rowData.sendDate)) {
        errArrInvalidValue.push(getErrorDataItem('sendDate'));
      } else if (isPastDate(rowData.sendDateValue, date)) {
        // 登録日より過去の日付
        errArrBeforeRegistDate.push(getErrorDataItem('sendDate'));
      }
    }

    // 配信時分
    if (rowData.sendDateTime.length > 0 && 
      (rowData.sendDateTimeStyle.numFmt == "mm-dd-yy" || isInvalidDate(rowData.sendDateTime) || dateJudg(rowData.sendDateTime))){
      errArrInvalidValue.push(getErrorDataItem('sendDateTime'));
    }

    // 掲載終了日
    if (rowData.publishEndData.length > 0 && (isInvalidDate(rowData.publishEndData))) {
      errArrInvalidValue.push(getErrorDataItem('publishEndAt'));
    } else if (rowData.publishEndData.length > 0){
      // 登録日より過去の日付
      if (isPastDate(rowData.publishEndAt, date)) {
        errArrBeforeRegistDate.push(getErrorDataItem('publishEndAt'));
      } 
      // 配信日より過去の日付
      if (rowData.sendDate.length > 0 && isPastDate(rowData.publishEndAt, rowData.sendDateValue)) {
        errArrBeforeSendDate.push(getErrorDataItem('publishEndAt'));
      }
    }

    // 配信先
    if (rowData.select.length > 0 && rowData.select !== "　" && !(rowData.select == "topic" || rowData.select == company?.displayId)){
      errArrInvalidValue.push(getErrorDataItem('select'));
    }

    // 配信先グループ
    if(rowData.topic.length > 0){
      const colNoList: number[] = [];
      rowData.topic.map((item:any) =>{
        let groupFlg = groupList?.some(group => group.name == item.name);
        if(rowData.select == company?.displayId && rowData.topic.length > 0){
          colNoList.push(item.col);
        }else if (!groupFlg) {
          colNoList.push(item.col);
        }
      });
      if(colNoList.length > 0){
        errArrInvalidValue.push({colNo: colNoList, colName: "配信先グループ"});
      }
    }

    // 返信ボタン
    if(rowData.replyButton.length > 0){
      let replyButtonFlg = replyButtonList?.some(replyButton => replyButton.name == rowData.replyButton);
      if ((messageKinds == "message" && !replyButtonFlg) || (messageKinds == "schedule" && !(rowData.replyButton == "予定表の出欠" || rowData.replyButton == "予定表の出欠(オンライン)"))) {
        errArrInvalidValue.push({colNo: [endCol], colName: "返信ボタン"});
      }
    }

    // --　予定表のみ --
    if(messageKinds == "schedule"){

      // イベントタイプ
      if(rowData.eventType.length > 0){
        let idx = company?.eventType?.indexOf(rowData.eventType) ?? -1;
        if (idx < 0) {
          errArrInvalidValue.push(getErrorDataItem('eventType', endCol));
        }
      }

      // イベント開催日
      let isSameSendDay = false;
      if (rowData.eventAtDate.length > 0 && (rowData.eventAtStyle.numFmt == "h:mm" || isInvalidDate(rowData.eventAtDate) || timeJudg(rowData.eventAtDate))){
        errArrInvalidValue.push(getErrorDataItem('eventAt', endCol));
      } else if(rowData.eventAt || rowData.eventAtDateTime) {
        const targetDate = rowData.eventAt !== undefined ? rowData.eventAt : rowData.eventAtDateTime;

        // 登録日より過去の日付
        if (isPastDate(targetDate, date)) {
          errArrBeforeRegistDate.push(getErrorDataItem('eventAt', endCol));
        }
        // 配信日より過去の日付
        if (rowData.sendDate.length > 0 && isPastDate(targetDate, rowData.sendDateValue)) {
          errArrBeforeSendDate.push(getErrorDataItem('eventAt', endCol));
        }
        // 掲載終了日より過去の日付
        if (rowData.publishEndData.length > 0 && isPastDate(rowData.publishEndAt, targetDate)) {
          errArrBeforePubEndDate.push(getErrorDataItem('eventAt', endCol));
        }

        // 配信日と開催日が同日
        isSameSendDay = compareDateOnlyYmd(stringToDate(rowData.sendDate), targetDate) === 0;
      }

      // イベント開始時間
      if (rowData.eventAtTime.length > 0 && 
        (rowData.eventAtTimeStyle.numFmt == "mm-dd-yy" || isInvalidDate(rowData.eventAtTime) || dateJudg(rowData.eventAtTime))){
        errArrInvalidValue.push(getErrorDataItem('eventAtTime', endCol));

      } else if (isSameSendDay) {
        // 配信日 = 開催日
        const compareTime = compareDateOnlyTime(nineHourMinusDate(stringToDate(rowData.sendDateTime)), nineHourMinusDate(stringToDate(rowData.eventAtTime)));
        if (compareTime !== undefined && compareTime < 1) {
          // 配信時間 >= 開始時間
          errArrBeforeSendTime.push(getErrorDataItem('eventAtTime', endCol));
        }
      }

      // イベント終了時間
      if (rowData.eventEndAtTime.length > 0 && 
        (rowData.eventEndAtTimeStyle.numFmt == "mm-dd-yy" || isInvalidDate(rowData.eventEndAtTime) || dateJudg(rowData.eventEndAtTime))){
        errArrInvalidValue.push(getErrorDataItem('eventEndAt', endCol));

      } else {
        const compareTime = compareDateOnlyTime(nineHourMinusDate(stringToDate(rowData.eventAtTime)), nineHourMinusDate(stringToDate(rowData.eventEndAtTime)));
        if (compareTime !== undefined && compareTime < 1) {
          // 開始時間 >= 終了時間
          errArrBeforeEventTime.push(getErrorDataItem('eventEndAt', endCol));
        }
      }

      // ミーティングURL
      if (rowData.link.length > 0 && !(rowData.link.startsWith('https://'))){
        errArrInvalidValue.push(getErrorDataItem('link', endCol));
      }
    }

    // １行分のエラーを設定
    const targetRowError = [];
    if (errArrRequired.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_REQUIRED_FIELD, errArrRequired));
    }
    if (errArrInvalidValue.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_INVALID_VALUE, errArrInvalidValue));
    }
    if (errArrBeforeRegistDate.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_DATE_TIME_PASTDATE, errArrBeforeRegistDate));
    }
    if (errArrBeforeSendDate.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_DATE_TIME_SETTING, errArrBeforeSendDate));
    }
    if (errArrBeforePubEndDate.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_DATE_TIME_PUB_END, errArrBeforePubEndDate));
    }
    if (errArrBeforeSendTime.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_TIME_BEFORE_SEND, errArrBeforeSendTime));
    }
    if (errArrBeforeEventTime.length > 0) {
      targetRowError.push(getErrorData(ConstMessage.IMPORT_ERR_TIME_BEFORE_EVENT_START, errArrBeforeEventTime));
    }
    return targetRowError;
  };

  /** エラーファイルのダウンロード */
  const downloadErrorFile = () => {
    const fileKind = messageKind == "message" ? "お知らせ" : "予定表";
    const fileURL = window.URL.createObjectURL(targetFile as Blob);
    const promise = new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = async () => {
        const result = xhr.response;
        const data = new Uint8Array(result);
        try{
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data as any);
          const worksheet = workbook.worksheets[0];
          worksheet.pageSetup = {orientation:'portrait'};
          const columnRowNum = annotation.length + 3;
          const columnHeader = worksheet.getRow(columnRowNum);
          
          const replyButtonName = messageKind === "message" ? endColumn[0].header : endColumn[0].header + "＊";
          const messageEndCol = getTargetCol(columnHeader, replyButtonName);
          const scheduleEndCol = messageEndCol + scheduleColumn.length;
          const endCol = messageKind == "message" ? messageEndCol: scheduleEndCol;
          const resultCol = endCol + 1;
          const errorInfoCol = endCol + 2;
          if (getTargetCol(columnHeader, '取込結果') < 0) {
            worksheet.getRow(annotation.length + 3).getCell(resultCol).value = '取込結果';
            worksheet.getRow(annotation.length + 3).getCell(errorInfoCol).value = 'エラー内容';
          }
          const borderStyle = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          }
          const alignmentStyle = {
            horizontal: "center",
            vertical: "middle"
          }
          // エラー行の初期値の書式を取得
          const defaultStyle = worksheet.getCell('D1').style;

          /** 文字列折り返しの書式 */
          const warpTextAlignStyle = {
            horizontal: 'left',
            vertical: 'middle',
            wrapText: true,
          };

          const startRow = columnRowNum + 2;
          for (let i = startRow; i < checkedRowCnt; i++) {
            const row = worksheet.getRow(i);
            const targetDataInfo = fileDataInfo.filter((data) => data.rowNumber === i)[0];
            // インポート対象データの場合
            if (targetDataInfo !== undefined) {
              if (targetDataInfo.status === "success") {
                // 登録成功データ
                for (let j = 2; j < endCol + 1; j++) {
                  row.getCell(j).style.fill = undefined;
                }
                row.getCell(resultCol).value = "○";
                row.getCell(errorInfoCol).value = "";
              } else if (targetDataInfo.status === "failed") {
                // 登録失敗データ
                for (let j = 2; j < endCol + 1; j++) {
                  const cellStyle = row.getCell(j).style;
                  row.getCell(j).style = Object.create(defaultStyle);
                  //　配信日・時分・掲載終了日・配信先・イベント開催日・開始時間・終了時間の書式設定
                  if (j === COL_NUM_SENDDATE
                     || j === COL_NUM_SENDTIME
                     || j === COL_NUM_PUB_END
                     || j === COL_NUM_SELECT_DELIVER
                     || j === messageEndCol + COL_NUM_EVENTDATE
                     || j === messageEndCol + COL_NUM_EVENTSTART
                     || j === messageEndCol + COL_NUM_EVENTEND
                  ) {
                    // 日付・時刻の設定（配信先は除く）
                    if(j !== COL_NUM_SELECT_DELIVER){
                      row.getCell(j).style.numFmt = cellStyle.numFmt;
                    }
                    // 中央ぞろえに設定
                    row.getCell(j).style.alignment = alignmentStyle as ExcelJS.Alignment;

                  } else if (j === COL_NUM_TITLE || j === COL_NUM_BODY) {
                    // タイトルと内容は、折り返し書式を設定
                    row.getCell(j).style.alignment = warpTextAlignStyle as ExcelJS.Alignment;
                  }

                  row.getCell(j).protection = { locked: false };
                  row.getCell(j).style.border = borderStyle as ExcelJS.Borders;
                }
                const infoStr: string[] = [];
                targetDataInfo.info.forEach((items: any) => {
                  let colNameStr = "";
                  items.data.forEach((item: any) => {
                    colNameStr += `[${item.colName}]`;
                    item.colNo.forEach((col: any) => {
                      row.getCell(col).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb :'FFFFCCFF' },
                      }
                    });
                  });
                  infoStr.push(colNameStr + items.message);
                });
                row.getCell(resultCol).value = "×";
                row.getCell(errorInfoCol).value = infoStr.join('／');
              } else if (targetDataInfo.status === "error") {
                // 処理中にエラーが発生したデータ
                const infoStr: string[] = [];
                row.getCell(resultCol).value = "×";
                row.getCell(errorInfoCol).value = infoStr.join('／');
              }
            }
            setProgress(Math.round((i - startRow) / (worksheet.rowCount + 1 - startRow) * 100))
          }

          // ダウンロードリンク
          const a = document.createElement("a");
          // BOM
          const bom = "\uFEFF";
          const uint8Array = await workbook.xlsx.writeBuffer();
          const blob = new Blob([uint8Array], { type: "application/octet-binary" });
          a.href = window.URL.createObjectURL(blob);

          // エラーファイルの先頭に付与する文字列を取得
          const fileNamePrefix = getImportErrorFileNamePrefix(targetFile?.name);
          a.download = `${fileNamePrefix}${fileKind}_${company?.name}_${convertDateToStringCompactFormat(new Date())}.xlsx`;
          a.click();
          a.remove();
          const date = new Date();
          resolve(null);
        } catch (e: any) {
          console.error(e);
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_FILE_EXPORT_ERROR, "danger")));
          resolve(null);
        }
      };
      xhr.responseType = "arraybuffer";
      xhr.open("GET", fileURL);
      xhr.send(null);
    });
    return promise;
  }

  // エラーデータを返す
  const getErrorDataItem = (name: string, endCol?: number) => {
    if(endCol){
      return {colNo: [getScheduleColumnIndex(name, endCol)], colName: getScheduleColumnHeader(name)};
    }
    return {colNo: [getColumnIndex(name)], colName: getColumnHeader(name)};
  }

  // インデックスを返す
  const getColumnIndex = (name: string) => {
    return column.findIndex((target) => target.key === name) + 1;
  }

  // インデックスを返す(予定表)
  const getScheduleColumnIndex = (name: string, endCol: number) => {
    return scheduleColumn.findIndex((target) => target.key === name) + 1 + endCol;
  }

  // カラム名を返す
  const getColumnHeader = (name: string) => {
    return column.find((target) => target.key === name)?.header;
  }

  // カラム名を返す(予定表)
  const getScheduleColumnHeader = (name: string) => {
    return scheduleColumn.find((target) => target.key === name)?.header;
  }

  // エラーデータセット
  const getErrorData = (errMessage: string, errArr: any[]) => {
    return {
        message: errMessage,
        data: errArr
      };
  }

  // 汎用ダイアログ用
  // toggleDialog
  // initDialog
  const toggleDialog = () => {
    setIsOpenDialog(isOpenDialog);
  };
  const initDialog = () => {
    setDialogTitle("");
    setDialogChildren("");
    setDialogActions([]);
  };

  return(
    <div className="h-full">
      <Progress
        open={loadProgress >= 0 && loadProgress < 100}
        progressNum={loadProgress}
        color={"green"}
      />
      <div className="sm:flex sm:items-center p-6">
        <div className="sm:flex-auto">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">お知らせ・予定表 Excel取込</h2>
          <h3 className="mb-1">お知らせおよび予定表は下書きで登録されます</h3>
          <h3>詳細についてはマニュアルをご参照ください</h3>
          <div className="flex mt-8 h-12 items-center" style={{width:500}}>
            <h3 className="w-1/6 text-sm ml-5 text-center">お知らせ</h3>
            <Button
              size="sm"
              className={"h-9 ml-5 text-sm sm:items-center rounded-full"}
              onClick={() => onDownload(messageRef)}
              children={"フォーマットダウンロード"}
            />
            <InputFile
              id="message"
              size="sm"
              className={"h-9 w-15 mr-5 ml-5 text-sm sm:items-center rounded-full"}
              onChange={(e) => {
                const files = e.target.files;
                if(files && files[0]){
                  setTargetFile(files[0]);
                  onImport("message", 'xlsx', files[0], e);
                }
              }}
              children={"Excel取込"}
            />
          </div>
          <div className="flex mt-5 mb-2 h-12 items-center" style={{width:500}}>
            <h3 className="w-1/6 text-sm ml-5 text-center">予定表</h3>
            <Button
              size="sm"
              className={"h-9 ml-5 text-sm sm:items-center rounded-full"}
              onClick={() => onDownload(scheduleRef)}
              children={"フォーマットダウンロード"}
            />
            <InputFile
              id="schedule"
              size="sm"
              className={"h-9 w-15 mr-5 ml-5 text-sm sm:items-center rounded-full"}
              onChange={(e) => {
                const files = e.target.files;
                if(files && files[0]){
                  setTargetFile(files[0]);
                  onImport("schedule", 'xlsx', files[0], e);
                }
              }}
              children={"Excel取込"}
            />
          </div>
          <div className="mt-8 border border-red-500 bg-[#FEE2E2] p-4 rounded max-w-lg" style={{whiteSpace:'pre-wrap'}}>
            <h3>{`※ 注意事項 ※\n「Excel取込」後、以下エラーファイルが出力されますので、\n該当箇所を修正し、このファイルを再取込みしてください。\n`}</h3>
            <h3 className="text-blue-700">{`取込エラー_予定表／お知らせ_[団体名]_yyyymmdd.xlsx\n\n`}</h3>
            <h3>{`また、以下の初回取込時のファイルを修正、再取込すると、\n取込み済みのお知らせ、予定表が重複登録されますので、\n修正は上記方法にて実施してください。\n`}</h3>
            <h3 className="text-blue-700">{`一括登録フォーマット（お知らせ／予定表）.xlsx`}</h3>
          </div>
        </div>
      </div>
      {isLoad ? <Spiner /> : (
        <>
          <ModalAndAlmightyDialog
            toggle={toggleDialog}
            open={isOpenDialog}
            title={dialogTitle}
            children={dialogChildren}
            actions={dialogActions}
            height={"72"}
            closeOnClickOutside={false}
          />
        </>
      )} 
    </div>
  )
};